import { filter, map, pipe, uniqueBy } from '@vestigas/utils';

import { type DeliveryNoteBody } from '../types';

/**
 * Returns the shipping marks for a given delivery note.
 * @param assetBody - The body of the delivery note to get the shipping marks for.
 * @returns An object with shipping mark codes as keys and related values as values for the given delivery note.
 */
export const getShippingMarks = (
  assetBody: DeliveryNoteBody,
): Array<{ code: string; value: string }> => {
  if (!assetBody?.transaction?.delivery?.shippingMarks?.length) {
    return [];
  }

  const shippingMarks = pipe(
    assetBody.transaction.delivery.shippingMarks,
    map(({ code, value }) => ({ code, value })),
    uniqueBy(({ code, value }) => [code, value].join(':')),
    filter(Boolean),
  );

  return shippingMarks;
};
